// // XNGAGE CONFIDENTIAL
// // __________________________
// //
// // Copyright (C) 2023 Xngage - All Rights Reserved
// //
// // All code or information contained herein is, and remains the
// // property of Xngage LLC and its customers.  The intellectual
// // and technical concepts contained are proprietary to Xngage LLC
// // and may be covered by U.S. and Foreign Patents, patents in
// // process, and are protected by trade secret or copyright law.
// // Dissemination of this information or reproduction of this material
// // is strictly forbidden unless prior written permission is obtained
// // from Xngage LLC.
// //

import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, LoadRecentlyPurchased } from "@insite/client-framework/Store/Components/PurchasedProducts/Handlers/LoadPurchasedProducts";


export const LoadRecentlyPurchasedFromHeader: typeof LoadRecentlyPurchased = props => {
    if (props.parameter.purchaseType !== "recentlyFromHeader") {
        return;
    }
    props.getProductCollectionParameter = { filter: "recentlyPurchased", pageSize: 4 };
};

addToChainBefore(chain, LoadRecentlyPurchased, LoadRecentlyPurchasedFromHeader);